<ng-container *ngFor="let key of stateLicenseKeys">
  <div
    *ngIf="!!log && hasLog(key, log)"
    [innerHTML]="normalizeLog(key, log) | changeLogsDiffHTML: stateLicenseLookup : null"
  ></div>
</ng-container>
